const Logo = ({ size = 36 }) => (
  <img
    src="/brand.jpg"
    alt="Michael C Streamline logo"
    data-testid="brand-logo"
    className="shrink-0 rounded-xl object-cover"
    style={{ width: size, height: size }}
  />
);

export default Logo;
